import axios from 'axios';

const newDev = process.env.REACT_APP_NEW_DEV;
const newProd = process.env.REACT_APP_NEW_PROD;

const apiUrl = process.env.REACT_APP_API_URL;
const proxyUrl = process.env.REACT_APP_PROXY_URL;
const dbUser = process.env.REACT_APP_DB_USER;
const dbPassword = process.env.REACT_APP_DB_PASSWORD;

const local = 'localhost';
const proxy = proxyUrl;
const prod = apiUrl;

let currentUrl = newProd;

const api = axios.create({
	baseURL: `http://${local}:${process.env.REACT_APP_API_PORT}`,
});

export const requestData = async (endpoint) => {
	const { data } = await api.get(endpoint);
	return data;
};

// Função para gerar o cabeçalho de autenticação Basic
const getBasicAuthHeader = () => {
	const username = dbUser; // Substitua pelo username correto
	const password = dbPassword; // Substitua pela senha correta
	const token = btoa(`${username}:${password}`); // Codifica as credenciais em Base64
	return {
		Authorization: `Basic ${token}`,
	};
};

/* BOLETINS a*/
export const requestBoletins = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/documentos/boletins/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao receber os boletins. Tente novamente mais tarde.',
		};
	}
};

/* EVENTOS */
export const requestEvents = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/eventos/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar eventos. Tente novamente mais tarde.',
		};
	}
};

export const requestEventCreate = async (body, token) => {
	try {
		const { data } = await axios.post(`${currentUrl}/eventos/`, body, {
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* ATUALIZAÇÃO DO MAPA */
export const requestMapAtt = async () => {
	try {
		const { data } = await axios.get(
			`https://backend-dev.subhue.org/mapa/ultima-atualizacao-leito/`
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar atualização do mapa. Tente novamente mais tarde.',
		};
	}
};

/* RESET PASSWORD  modify from new branch*/
export const requestResetPassword = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/auth/password-reset/`,
			body
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNewPassword = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/auth/password-reset/confirm/`,
			body
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

/* LOGIN */
export const requestAuthLogin = async (body) => {
	try {
		const { data } = await axios.post(`${currentUrl}/auth/login/`, body);
		return data;
	} catch (error) {
		if (error?.response?.data?.detail) {
			return {
				error: error?.response?.data?.detail[0],
			};
		} else {
			return {
				error: error?.response?.data,
			};
		}
	}
};

export const requestUserDetails = async (token, usuario) => {
	try {
		const { data } = await axios.get(`${currentUrl}/usuarios/${usuario}/`, {
			headers: { Authorization: `Token ${token}` },
		});
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar detalhes de usuario. Tente novamente mais tarde.',
		};
	}
};

export const requestEmailSend = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/contato/enviar-email/`,
			body,
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);
		return data;
	} catch (error) {
		console.log(error);
		return {
			error: 'Erro ao enviar um email notificando o usuario. Tente novamente mais tarde.',
		};
	}
};

export const requestUsersCnes = async (token, cnes) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/usuarios/?unidade_id=${cnes}`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error.response,
		};
	}
};

export const requestDetailsCnes = async (token, id) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/usuarios/?unidade_id=${id}`, // Adicionado filtro por cnes
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		console.error('Erro ao buscar detalhes de usuário:', error.message);
		return {
			error: 'Erro ao buscar detalhes de usuário para gestores. Tente novamente mais tarde.',
		};
	}
};

export const requestUpdatePerfil = async (token, username, body) => {
	try {
		// Verificar se o perfil_id está presente no corpo
		if (!body.perfil_id) {
			console.error(
				"Erro: O 'perfil_id' é obrigatório para atualizar o perfil."
			);
			return {
				error: "O 'perfil_id' é obrigatório para atualizar o perfil.",
			};
		}

		// Log para depuração
		console.log('Enviando requisição para atualizar perfil:', {
			url: `${currentUrl}/usuarios/${username}/unidades/`,
			body,
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});

		const { data } = await axios.put(
			`${currentUrl}/usuarios/${username}/unidades/`,
			body, // Corpo da requisição com perfil_id e demais dados
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);

		// Log de sucesso
		console.log('Perfil atualizado com sucesso:', data);
		return data;
	} catch (error) {
		// Log detalhado do erro
		console.error('Erro ao atualizar perfil:', {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
			headers: error.response?.headers,
		});

		return {
			error:
				error.response?.data ||
				'Erro ao atualizar as permissões do usuário. Tente novamente mais tarde.',
		};
	}
};

export const requestDeletePerfil = async (token, username, perfilId) => {
	try {
		// Verificar se o perfilId está presente
		if (!perfilId) {
			throw new Error(
				"O 'perfil_id' é obrigatório para desativar o perfil."
			);
		}

		// Log para depuração
		console.log('Enviando requisição para desativar perfil:', {
			url: `${currentUrl}/usuarios/${username}/unidades/`,
			body: { perfil_id: perfilId, ativo: false },
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});

		const { data } = await axios.put(
			`${currentUrl}/usuarios/${username}/unidades/`,
			{ perfil_id: perfilId, ativo: false }, // Atualiza o status para inativo
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);

		// Log de sucesso
		console.log('Perfil desativado com sucesso:', data);
		return data;
	} catch (error) {
		// Log detalhado do erro
		console.error('Erro ao desativar perfil:', {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
			headers: error.response?.headers,
		});

		return {
			error:
				error.response?.data ||
				'Erro ao desativar o perfil. Tente novamente mais tarde.',
		};
	}
};

export const requestUpdateRole = async (token, username, body) => {
	try {
		// Verificar se o perfil_id está presente no corpo
		if (!body.perfil_id) {
			console.error(
				"Erro: O 'perfil_id' é obrigatório para atualizar o papel."
			);
			return {
				error: "O 'perfil_id' é obrigatório para atualizar o papel.",
			};
		}

		// Log para depuração
		console.log('Enviando requisição para atualizar papel:', {
			url: `${currentUrl}/usuarios/${username}/roles/`,
			body,
			headers: {
				Authorization: `Token ${token}`,
				'Content-Type': 'application/json',
			},
		});

		const { data } = await axios.put(
			`${currentUrl}/usuarios/${username}/roles/`,
			body, // Corpo da requisição com perfil_id e demais dados
			{
				headers: {
					Authorization: `Token ${token}`,
					'Content-Type': 'application/json',
				},
			}
		);

		// Log de sucesso
		console.log('Papel atualizado com sucesso:', data);
		return data;
	} catch (error) {
		// Log detalhado do erro
		console.error('Erro ao atualizar papel:', {
			message: error.message,
			response: error.response?.data,
			status: error.response?.status,
			headers: error.response?.headers,
		});

		return {
			error:
				error.response?.data ||
				'Erro ao atualizar o papel do usuário. Tente novamente mais tarde.',
		};
	}
};

export const requestUserRegisters = async (body) => {
	try {
		const { data } = await axios.post(`${currentUrl}/auth/registro/`, body);
		return data;
	} catch (error) {
		let detail = '';
		if (error.response?.data?.username) {
			detail = error.response?.data?.username;
		} else if (error.response?.data?.email) {
			detail = error.response?.data?.email;
		} else if (error.response?.data?.password) {
			detail = error.response?.data?.password;
		}
		console.log(error, detail);
		return {
			error: detail,
			detail: error.response?.data,
		};
	}
};

/* EMAIL DE SUPORTE */
export const requestEmail = async (body) => {
	try {
		const { data } = await axios.post(`${currentUrl}/contato/`, {
			nome: body.nome,
			email: body.email,
			telefone: body.telefone,
			mensagem: body.mensagem,
		});
		return data;
	} catch (error) {
		return {
			error: 'Erro ao enviar email. Tente novamente mais tarde.',
		};
	}
};

/* PUBLICAÇÕES BLOG */
export const requestPublics = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/blog/noticias/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades. Tente novamente mais tarde.',
		};
	}
};

/* UNIDADES */
export const requestPadi = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/padi/`);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestUnitToken = async (body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/verificar_token_unidade/`,
			body
		);

		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestUnitSectors = async (unidade_id) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/unidades/${unidade_id}/setores/`
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNewUnits = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/unidades/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades. Tente novamente mais tarde.',
		};
	}
};

export const requestUnits = async () => {
	try {
		const { data } = await axios.get(`${currentUrl}/unidades/`);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar unidades. Tente novamente mais tarde.',
		};
	}
};

// NOTIFICAÇÕES

export const requestExcelExport = async (
	user_token,
	unit_token,
	initialDate,
	finalDate
) => {
	try {
		let url = `${currentUrl}/incidentes/export/`;

		const params = new URLSearchParams();

		if (initialDate && finalDate) {
			params.append('data_notificacao_inicio', initialDate);
			params.append('data_notificacao_fim', finalDate);
		}

		if (unit_token) {
			params.append('token_notificacao', unit_token);
		}

		url += `?${params.toString()}`;

		const response = await axios.get(url, {
			headers: { Authorization: `Token ${user_token}` },
			responseType: 'blob', // ESSENCIAL!!!
		});

		return { blob: response.data };
	} catch (error) {
		console.error('Erro:', error);
		return {
			error: 'Erro ao exportar o documento. Tente novamente mais tarde.',
		};
	}
};

export const requestNoteCreate = async (body) => {
	try {
		// Construção do objeto com base nos dados recebidos

		const notificationPayload = {
			token_notificacao: body.unidade_token_notificacao,
			data_ocorrencia: body.data_ocorrencia,
			notificante: body.notificador,
			nome_paciente: body.nome_paciente,
			nascimento_paciente: body.nascimento_paciente || null,
			prontuario: body.prontuario,
			sexo_paciente: body.sexo_paciente?.toUpperCase()[0] || '', // Valor padrão
			tipo_incidente: body.other_checked ? 'OUTROS' : body.tipo_incidente, // Se outro for marcado
			tipo_incidente_outros: body.other_checked
				? body.tipo_incidente
				: '',
			descricao: body.descricao_ocorrencia,
			acoes_imediatas: body.acoes_imediatas,
			medida_preventiva: body.medida_preventiva,
			envolve_paciente: body.envolve_paciente,
			fato_presenciado: body.fato_presenciado, // Booleano direto
			quem_presenciou:
				body.quem_presenciou === 'ninguem' ? '' : body.quem_presenciou,
			setor: body.setor,
			turno: body.turno[0],
		};

		// Configuração do cabeçalho com autenticação

		// Enviando o objeto para a API
		const { data } = await axios.post(
			`${currentUrl}/incidentes/notificacoes/`,
			notificationPayload
		);

		return data;
	} catch (error) {
		console.error('Erro ao criar notificação:', error);
		return {
			error: error.response.data,
		};
	}
};

export const requestDelayNotes = async (token, unidade, status, atraso) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/visao-geral/?status=${status}&token_notificacao=${unidade}`,

			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar todas as notificações. Tente novamente mais tarde.',
		};
	}
};

export const requestListNotes = async (token, unidade) => {
	try {
		let url = `${currentUrl}/incidentes/notificacoes/?protocolo__token_notificacao=${unidade}`;
		if (unidade === undefined || unidade === null || unidade === '') {
			url = `${currentUrl}/incidentes/notificacoes/`;
		}
		const { data } = await axios.get(url, {
			headers: { Authorization: `Token ${token}` },
		});
		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar todas as notificações. Tente novamente mais tarde.',
		};
	}
};

export const requestListNotesByProtocol = async (token, protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/notificacoes/${protocolo}`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao listar notificações por protocolo. Tente novamente mais tarde.',
		};
	}
};

export const requestNewClassCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/classificacoes/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestClassCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/notificacoes/classificacoes/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao classificar a notificação. Tente novamente mais tarde.',
		};
	}
};

export const requestInvCreation = async (token, body, classificacao) => {
	try {
		const { data } = await axios.put(
			`${currentUrl}/notificacoes/investigacoes/${classificacao}/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNewInvCreation = async (token, protocol) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/investigacoes/`,
			{ protocolo: protocol },
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestAllInvestigations = async (token, param) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}${
				param
					? `/incidentes/classificacoes/?protocolo__status=${param}`
					: '/incidentes/classificacoes/?investigar=true'
			}`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestNotesByInv = async (token, userName) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/classificacoes/por-investigador/${userName}/`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestInvConclude = async (token, id, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/investigacoes/${id}/concluir/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

/* RECUPERA OS DADOS SALVOS DE CADA PARTE DO FORMULARIO */
export const requestSavedData = async (token, id, type) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/investigacoes/${id}/${type}/`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);

		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestSaveForm = async (token, id, type, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/investigacoes/${id}/${type}/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		console.log(error.response.data);
		return {
			error: error,
		};
	}
};

export const requestNewAvalCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/incidentes/avaliacoes-finais/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error,
		};
	}
};

export const requestAvalCreation = async (token, body) => {
	try {
		const { data } = await axios.post(
			`${currentUrl}/notificacoes/avaliacoes-finais/`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: error.response.data,
		};
	}
};

export const requestNoteTimeLine = async (protocolo) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/consulta/${protocolo}/`
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao trazer a timeline da notificação. Tente novamente mais tarde.',
		};
	}
};

export const requestAvalList = async (token) => {
	/* console.log(token, id); */
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/avaliacoes-finais/?decisao=ACEITA`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		console.log(error.response.data);
		return {
			error: 'Erro ao listar avaliações por id. Tente novamente mais tarde.',
		};
	}
};

export const requestInvList = async (token, classificacao) => {
	try {
		const response = await axios.get(
			`${currentUrl}/notificacoes/investigacoes/${classificacao}/`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		/* console.log('Resposta da API:', response); */

		return response.data;
	} catch (error) {
		console.error(
			'Erro na requisição:',
			error.response?.data || error.message
		);
		return {
			error: 'Erro ao listar investigações. Tente novamente mais tarde.',
		};
	}
};

export const requestClassByProtocol = async (token, protocol) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/incidentes/classificacoes/${protocol}/`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar classificações por protocolo. Muitas requisições',
		};
	}
};

export const requestNotesByProtocol = async (protocol) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/notificacoes/notificacoes/${protocol}/`
		);

		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar notificações. Muitas requisições',
		};
	}
};

export const requestAllNotes = async (token) => {
	try {
		const { data } = await axios.get(
			`${currentUrl}/notificacoes/notificacoes/`,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar notificações. Muitas requisições',
		};
	}
};

/* REQUSITA AS NOTIFICAÇÕES POR UNIDADE */

/* export const requestNotesByUnit = async (protocol) => {
	try {
		const { data } = await axios.get(`${currentUrl}/notificacoes/notificacoes/`);

		console.log(data);
		return data;
	} catch (error) {
		return {
			error: 'Erro ao buscar notificações. Muitas requisições',
		};
	}
}; */

// DEPRECATED

export const requestNoteLogin = async (input, senha) => {
	try {
		const { data } = await axios.post(`http://${local}:3002/noteLogin`, {
			input,
			senha,
		});
		return data;
	} catch (error) {
		return { error: error.message };
	}
};

export const requestLogin = async (input, senha) => {
	try {
		const { data } = await axios.post(`http://${local}:3002/login`, {
			input,
			senha,
		});
		return data;
	} catch (error) {
		return { error: error.response.data.message };
	}
};

export const requestCreate = async (body) => {
	try {
		const response = await axios.post(
			`http://${local}:3002/register`,
			body
		);
		return { data: response.data, status: response.status };
	} catch (error) {
		return { error: error.response.data.message };
	}
};

export const requestCreateRegister = async (token, body) => {
	try {
		const response = await axios.put(
			`http://${local}:3002/register`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const requestGestData = async ({ token, nome }) => {
	try {
		const response = await axios.get(`http://${local}:3002/register`, {
			headers: { Authorization: `Bearer ${token}` },
			params: { nome },
		});
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

export const requestUsers = async ({ token }) => {
	try {
		const response = await axios.get(
			`http://${local}:3002/register/search`,
			{
				headers: { Authorization: `Bearer ${token}` },
			}
		);
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

export const updatePermissions = async ({ token, body }) => {
	try {
		const response = await axios.put(
			`http://${local}:3002/register/permissions`,
			body,
			{
				headers: { Authorization: `Token ${token}` },
			}
		);
		return response;
	} catch (error) {
		return error;
	}
};

//ESCALAS
export const requestCreateScale = async (token, body) => {
	try {
		const response = await axios.post(`http://${local}:3002/scale`, body, {
			headers: { Authorization: `Token ${token}` },
		});
		return response;
	} catch (error) {
		return error;
	}
};

export const requestScaleData = async (body) => {
	try {
		const response = await axios.get(
			`http://${local}:3002/scale/${body.id}`,

			{
				headers: {
					Authorization: body.token,
				},
			}
		);
		return response;
	} catch (error) {
		return error;
	}
};

export const requestAllScale = async (body) => {
	try {
		const response = await axios.get(
			`http://${local}:3002/scale/`,

			{
				headers: {
					Authorization: body.token,
				},
			}
		);
		return response;
	} catch (error) {
		return error;
	}
};

/* DASHBOARD */
export const requestDashboard = async ({ token }) => {
	try {
		const response = await axios.get(`${currentUrl}/dashboards`, {
			headers: { Authorization: `Token ${token}` },
		});
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

/* status-usuario */
export const statusUsuario = async ({ token }) => {
	try {
		const response = await axios.get(`${currentUrl}/status-usuario`, {
			headers: { Authorization: `Token ${token}` },
		});
		return response.data;
	} catch (error) {
		console.error('Erro na requisição:', error.response || error.message);
		return { error: error.response?.data || error.message };
	}
};

/* DOCUMENTOS */
export const requestDocuments = async () => {
	const { data } = await axios.get(`http://${local}:3002/document`);
	return data;
};
